import { AxiosResponse } from 'axios'

export function download (response: AxiosResponse) {
  let fileName = response.headers['x-suggested-filename']
  if (!fileName) {
    fileName = 'unknown-file'
  }
  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export function randomString (len: number): string {
  if (len <= 0) {
    throw Error('required positive number.')
  }
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < len; ++i) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function isBlob (data: unknown): data is Blob {
  return data !== null &&
    typeof data === 'object' &&
    data.constructor.name === Blob.name
}
